import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {StockUsageReportModel} from "./stock-usage-report.model";

@Component({
    selector: "wbo-stock-usage-report",
    templateUrl: "./stock-usage-report.component.html",
    providers: [provideReportModel(StockUsageReportModel)]
})
export class StockUsageReportComponent extends AbstractReportPage {
    constructor(public model: StockUsageReportModel) {
        super();
    }
}
